<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Analyse' }" replace>作业分析报告</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/AnalyseDeatil',query:{id:this.$route.query.id}}" replace>查看详情</el-breadcrumb-item>
				<el-breadcrumb-item>成绩概括</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="p_flex p_m_t_30 overflow" :style="{ height: height + 'px' }">
			<div class="tab_box type_size_22 small_hand p_m_r_30">
				<span v-for="(item, index) in tabList" :key="index" @click="goIndex(index)" :class="[tabIndex == index ? 'tab_com' : 'tab_coma']">{{ item }}</span>
			</div>
			<div class="p_f_1 tab_coma">
				<div class="p_flex p_f_a p_m_l_60 p_m_r_60  p_m_t_20 type_size_18">
					<span class="one-overflow ">{{name}}</span>
					<div class="p_flex center p_f_1   p_m_l_20">
						<span class="subject_color">{{ban}}</span>
						<el-divider direction="vertical"></el-divider>
						<span class="subject_yellow">{{already_submit}}人参与</span>
					</div>
				</div>
				<general-list v-if="tabIndex == 0" :height='height - 100'></general-list>
				<general-stay v-if="tabIndex == 1" :height='height - 100'></general-stay>
				<general-not v-if="tabIndex == 2" :height='height - 100'></general-not>
			</div>
		</div>
	</div>
</template>

<script>
import GeneralList from './commponents/generallist.vue';
import GeneralStay from './commponents/generalstay.vue';
import GeneralNot from './commponents/generalnot.vue'
export default {
	name: 'AnalyseGeneral',
	components: {
		GeneralList,
		GeneralStay,
		GeneralNot
	},
	data() {
		return {
			tabIndex: 0,
			tabList: ['已批改', '待批改', '未提交'],
			height: '0',
			name:"",
			ban:"",
			already_submit:""
		};
	},
	created(){
		this.$request.ajax(this).post("/api_teacher/analysis_report",{
           		job_publish_id: this.$route.query.id
			}).then(res=>{
				// console.log(res)
				this.name=res.data.name
				this.ban=res.data.classLevel.name
				this.already_submit=res.data.already_submit
			})
	},
	mounted() {
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/AnalyseGeneral') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		goIndex(i) {
			this.tabIndex = i;
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
// .tab_box {
// }
.tab_box > span {
	display: block;
	padding: 20px 140px 20px 60px;
}
.tab_com {
	background-color: #00af63;
	color: #ffffff;
}
.tab_coma {
	background: #ffffff;
}
.center{
		width: 260px;
	}
</style>



// WEBPACK FOOTER //
// src/components/homet/analyse/general.vue